import React from "react";
import Hero from "../components/Hero";
import ImpactMetricsStrip from "../components/ImpactMetricsStrip";
import Services from "../components/Services";
import OurExpectise from "../components/OurExpectise";
import Mission from "../components/Mission";
import CsrShowcase from "../components/CsrShowcase";
import { aboutData } from "../content/About";
import { home } from "../content/Home";

const Home = () => {
  return (
    <>
      <Hero />
      <ImpactMetricsStrip />
      {/* <About /> */}
      <Mission data={aboutData} />
      {/* <OurJourney /> */}
      <Services data={aboutData} />
      <OurExpectise data={home} />
      <CsrShowcase />
      {/* <AwardsAchievements /> */}
      {/* <CsrComp /> */}
      {/* <WhatWeDo /> */}
    </>
  );
};

export default Home;
